var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.7131,
    cy: 23,
    rx: 23.0189,
    ry: 23,
    fill: "#0C2780"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5615 15.8438H10.7078V25.4772H14.5615V15.8438Z",
    fill: "#15318D",
    stroke: "#F7F7F7",
    strokeWidth: 1.44447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6347 25.4805V29.3338",
    stroke: "#F7F7F7",
    strokeWidth: 1.44447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6347 11.9961V15.8495",
    stroke: "#F7F7F7",
    strokeWidth: 1.44447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2688 17.7773H18.4152V27.4108H22.2688V17.7773Z",
    fill: "#15318D",
    stroke: "#F7F7F7",
    strokeWidth: 1.44447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3419 27.4023V31.2557",
    stroke: "#F7F7F7",
    strokeWidth: 1.44447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3419 13.9258V17.7791",
    stroke: "#F7F7F7",
    strokeWidth: 1.44447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7199 15.8438H32.8662V25.4772H36.7199V15.8438Z",
    fill: "#15318D",
    stroke: "#F7F7F7",
    strokeWidth: 1.44447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7933 25.4805V29.3338",
    stroke: "#F7F7F7",
    strokeWidth: 1.44447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7933 11.9961V15.8495",
    stroke: "#F7F7F7",
    strokeWidth: 1.44447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9761 21.625H26.1224V31.2584H29.9761V21.625Z",
    fill: "#15318D",
    stroke: "#F7F7F7",
    strokeWidth: 1.44447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0493 31.2656V35.119",
    stroke: "#F7F7F7",
    strokeWidth: 1.44447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0493 17.7773V21.6307",
    stroke: "#F7F7F7",
    strokeWidth: 1.44447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon_02.bdf17137325afe250081a391025c3f2b.svg";
export { ForwardRef as ReactComponent };